import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BlogMetadata = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 30 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2517_691)">
          <mask
            id="mask0_2517_691"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="-1"
            y="0"
            width="26"
            height="23"
          >
            <rect x="-0.600098" y="0.000488281" width="25.275" height="22.7309" fill="url(#paint0_linear_2517_691)" />
          </mask>
          <g mask="url(#mask0_2517_691)">
            <path
              d="M1.42139 4.19434C1.42139 3.08977 2.31682 2.19434 3.42139 2.19434H20.5783C21.6829 2.19434 22.5783 3.08977 22.5783 4.19434V23.4006H1.42139V4.19434Z"
              fill="url(#paint1_linear_2517_691)"
            />
            <g filter="url(#filter0_d_2517_691)">
              <rect x="4.15015" y="14.7051" width="12.4998" height="2.92002" rx="1.46001" fill="#00FF94" />
            </g>
          </g>
          <circle cx="3.70517" cy="4.46128" r="0.935885" fill="#BAFFE2" fillOpacity="0.3" />
          <rect x="4.2002" y="8.56152" width="16.0495" height="1.43778" rx="0.71889" fill="#BAFFE2" fillOpacity="0.3" />
          <rect x="4.2002" y="11.0801" width="10.9449" height="1.43778" rx="0.71889" fill="#BAFFE2" fillOpacity="0.3" />
          <rect
            x="9.14526"
            y="3.95947"
            width="3.33319"
            height="1.43778"
            rx="0.71889"
            fill="#BAFFE2"
            fillOpacity="0.3"
          />
          <rect
            x="13.4785"
            y="3.95947"
            width="3.33319"
            height="1.43778"
            rx="0.71889"
            fill="#BAFFE2"
            fillOpacity="0.3"
          />
          <rect
            x="17.8115"
            y="3.95947"
            width="3.33319"
            height="1.43778"
            rx="0.71889"
            fill="#BAFFE2"
            fillOpacity="0.3"
          />
          <foreignObject x="5.88525" y="10.6504" width="18.8499" height="19.8306">
            <div
              style={{
                backdropFilter: 'blur(0.5px)',
                clipPath: 'url(#bgblur_0_2517_691_clip_path)',
                height: '100%',
                width: '100%',
              }}
            ></div>
          </foreignObject>
          <g filter="url(#filter1_ddd_2517_691)" data-figma-bg-blur-radius="1">
            <path
              d="M12.7606 22.1202L9.90575 12.2901C9.80031 11.927 10.1204 11.5828 10.4902 11.6616L20.3391 13.7618C20.7522 13.8498 20.8767 14.3787 20.5463 14.6419L18.0532 16.6275C17.8151 16.8171 17.8002 17.1736 18.0217 17.3824L20.4302 19.6528C20.6283 19.8395 20.6406 20.1503 20.458 20.3521L19.0489 21.9091C18.8593 22.1185 18.5341 22.1295 18.3309 21.9334L16.0298 19.7124C15.804 19.4945 15.4357 19.536 15.264 19.7987L13.6593 22.2542C13.4255 22.612 12.8798 22.5306 12.7606 22.1202Z"
              fill="white"
              fillOpacity="0.83"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_2517_691"
            x="1.15015"
            y="13.7051"
            width="18.4998"
            height="8.91992"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2517_691" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2517_691" result="shape" />
          </filter>
          <filter
            id="filter1_ddd_2517_691"
            x="5.88525"
            y="10.6504"
            width="18.8499"
            height="19.8306"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2517_691" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.5" />
            <feGaussianBlur stdDeviation="0.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
            <feBlend mode="normal" in2="effect1_dropShadow_2517_691" result="effect2_dropShadow_2517_691" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
            <feBlend mode="normal" in2="effect2_dropShadow_2517_691" result="effect3_dropShadow_2517_691" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_2517_691" result="shape" />
          </filter>
          <clipPath id="bgblur_1_2517_691_clip_path" transform="translate(-5.88525 -10.6504)">
            <path d="M12.7606 22.1202L9.90575 12.2901C9.80031 11.927 10.1204 11.5828 10.4902 11.6616L20.3391 13.7618C20.7522 13.8498 20.8767 14.3787 20.5463 14.6419L18.0532 16.6275C17.8151 16.8171 17.8002 17.1736 18.0217 17.3824L20.4302 19.6528C20.6283 19.8395 20.6406 20.1503 20.458 20.3521L19.0489 21.9091C18.8593 22.1185 18.5341 22.1295 18.3309 21.9334L16.0298 19.7124C15.804 19.4945 15.4357 19.536 15.264 19.7987L13.6593 22.2542C13.4255 22.612 12.8798 22.5306 12.7606 22.1202Z" />
          </clipPath>
          <linearGradient
            id="paint0_linear_2517_691"
            x1="12.0374"
            y1="18.0792"
            x2="12.0374"
            y2="22.7313"
            gradientUnits="userSpaceOnUse"
          >
            <stop />
            <stop offset="1" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2517_691"
            x1="11.9999"
            y1="8.67609"
            x2="11.9999"
            y2="23.4006"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#007E42" />
            <stop offset="1" stopColor="#00DB65" />
          </linearGradient>
          <clipPath id="clip0_2517_691">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)
